import { render } from "./msgzsStatistics.vue?vue&type=template&id=88de74ee&scoped=true"
import script from "./msgzsStatistics.vue?vue&type=script&lang=js"
export * from "./msgzsStatistics.vue?vue&type=script&lang=js"

import "./msgzsStatistics.vue?vue&type=style&index=0&id=88de74ee&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88de74ee"]])

export default __exports__